@if (featureEnabled && (userService.isAuthenticated$ | async)) {
  <div class="flex flex-row">
    <button type="button" pButton icon="pi pi-search" class="btn-right"></button>
    <p-autocomplete
      inputId="main-menu-search-ac"
      [(ngModel)]="selectedResult"
      [suggestions]="autoCompleteResults"
      (completeMethod)="autocompleteSearch($event)"
      [dropdown]="false"
      name="mainMenuSearchAutocomplete"
      class="autocomplete-left flex-grow-1"
      class="flex-grow-1"
      placeholder="Search for lipids, studies or datasets"
      emptyMessage="No results"
      [showEmptyMessage]="true"
      [autoHighlight]="false"
      [autofocus]="false"
      field="displayLabel"
      [fluid]="true"
      (onDropdownClick)="onSubmit($event)"
      (onSelect)="handleSelect($event)"
      (onUnselect)="handleUnSelect($event)"
      ><ng-template let-result #item>
      <div class="flex items-center gap-2">
        @if (result.kind === 'lipid') {
          <i class="fas fa-sitemap" style="color: var(--p-blue-500)"></i>
        } @else if (result.kind === 'study') {
          <i class="fa fa-vials" style="color: #d73027"></i>
        } @else if (result.kind === 'dataset') {
          <i class="fa fa-box-archive" style="color: #f46d43"></i>
        }
        <span>{{ result.displayLabel }}</span>
        @if (result.subLabel && result.subLabel !== result.displayLabel) {
          <span class="text-sm" style="color: var(--p-text-muted-color)">&nbsp;({{ result.subLabel }})</span>
        }
      </div>
    </ng-template>
  </p-autocomplete>
</div>
}
